import { render, staticRenderFns } from "./layoutAside.vue?vue&type=template&id=10e6d392&scoped=true"
import script from "./layoutAside.vue?vue&type=script&lang=js"
export * from "./layoutAside.vue?vue&type=script&lang=js"
import style0 from "./layoutAside.vue?vue&type=style&index=0&id=10e6d392&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e6d392",
  null
  
)

export default component.exports